<template>
  <div class="search-basic">
    <div class="row search-row">
      <div class="col-sm-4 search-col">
        <div class="search-item search-item__big">
          <div class="search-item__content">งานวิศวกรรม</div>
          <img
            src="https://thairung.co.th/wp-content/uploads/2020/09/TR_Edited-13.jpg"
            alt=""
          >
        </div>
      </div>
      <div class="col-sm-8 search-col">
        <div class="row search-row">
          <div class="col-md-5 search-col">
            <div class="search-item">
              <div class="search-item__content">งานปฏิบัติการ</div>
              <img
                src="https://thairung.co.th/wp-content/uploads/2020/09/DSC_8568.jpg"
                alt=""
              >
            </div>
          </div>
          <div class="col-md-7 search-col">
            <div class="search-item is-blue">
              <div class="search-item__content">งานฝ่ายการตลาด</div>
              <img
                src="https://thairung.co.th/wp-content/uploads/2020/09/shutterstock_329411348.jpg"
                alt=""
              >
            </div>
          </div>
        </div>
        <div class="row search-row">
          <div class="col-md-7 search-col">
            <div class="search-item">
              <div class="search-item__content">งานฝ่ายการขาย</div>
              <img
                src="https://thairung.co.th/wp-content/uploads/2020/09/man_happy.jpg"
                alt=""
              >
            </div>
          </div>
          <div class="col-md-5 search-col">
            <div class="search-item">
              <div class="search-item__content">
                ดูตำแหน่งงานทั้งหมด
                <icon-plus></icon-plus>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconPlus from '../../icons/Plus.vue'

export default {
  components: { IconPlus },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  &-row {
    margin-left: -15px;
    margin-right: -15px;
  }

  &-col {
    padding-left: 15px;
    padding-right: 15px;
  }

  &-item {
    position: relative;
    height: 205px;
    background: #00a5e1;
    margin-bottom: 30px;
    overflow: hidden;
    cursor: pointer;

    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.15);
      content: '';
    }

    &:hover {
      &::after {
        background: rgba(0, 0, 0, 0.25);
      }

      img {
        transform: scale(1);
      }
    }
    &__content {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      color: #fff;
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      z-index: 1;

      .is-blue & {
        color: #19499c;
      }

      svg {
        width: 40px;
        height: 40px;
        display: block;
        margin: 0 auto;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin: 0;
      transition: transform 0.3s;
      transform: scale(1.2);
    }

    &__big {
      height: 440px;
    }
  }
}
</style>